module.exports = __webpack_public_path__ + "static/img/banner2.3b5fd3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/banner2.png
// module id = Lp+D
// module chunks = 1